import { EntityKind, Entities } from "../state/entityKinds";
import { getXYindex } from "../state/gameState";

const directions = [
  [0, -1],
  [-1, 0],
  [1, 0],
  [0, 1],
];

function hasKind(
  board: Entities[][],
  kind_: EntityKind,
  x: number,
  y: number,
  cellFilter: (e: Entities[]) => Entities[]
): boolean {
  if (x < 0 || x > 15 || y < 0 || y > 15) {
    if (kind_ === EntityKind.StaticWall) {
      return true;
    } else {
      return false;
    }
  }
  return cellFilter(board[getXYindex(x, y)]).some(({ kind }) => kind_ === kind);
}

// CHECKS WITH EVERY
function hasKind_test(
  board: Entities[][],
  x: number,
  y: number,
  cellTest: (e: Entities) => boolean
): boolean {
  if (x < 0 || x > 15 || y < 0 || y > 15) {
    return true;
  }
  return board[getXYindex(x, y)].every(cellTest);
}
export function hasKind_some_test(
  board: Entities[][],
  x: number,
  y: number,
  cellTest: (e: Entities) => boolean
): boolean {
  if (x < 0 || x > 15 || y < 0 || y > 15) {
    return true;
  }
  return board[getXYindex(x, y)].some(cellTest);
}

// Ref:  https://gamedevelopment.tutsplus.com/tutorials/how-to-use-tile-bitmasking-to-auto-tile-your-level-layouts--cms-25673
// Also check out the placeholder template.
export function autoTile4bit(
  kind: EntityKind,
  board: Entities[][],
  x: number,
  y: number
): number {
  return autoTile4bit_filter(kind, board, x, y, (identity) => identity);
}

export function autoTile4bit_filter(
  kind: EntityKind,
  board: Entities[][],
  x: number,
  y: number,
  cellFilter: (e: Entities[]) => Entities[]
): number {
  let result = 0;
  let i = 1;
  for (const [x2, y2] of directions) {
    if (hasKind(board, kind, x + x2, y + y2, cellFilter)) {
      result |= i;
    }
    i *= 2;
  }
  return result;
}
export function autoTile4bit_self_check_ever(
  board: Entities[][],
  x: number,
  y: number,
  cellType: (e: Entities) => boolean
): number {
  let result = 0;
  let i = 1;
  for (const [x2, y2] of directions) {
    if (hasKind_test(board, x + x2, y + y2, cellType)) {
      result |= i;
    }
    i *= 2;
  }
  return result;
}
export function autoTile4bit_self_check_some(
  board: Entities[][],
  x: number,
  y: number,
  cellType: (e: Entities) => boolean
): number {
  let result = 0;
  let i = 1;
  for (const [x2, y2] of directions) {
    if (hasKind_some_test(board, x + x2, y + y2, cellType)) {
      result |= i;
    }
    i *= 2;
  }
  return result;
}

export function autoTile8bit(
  kind: EntityKind,
  board: Entities[][],
  x: number,
  y: number
) {
  throw new Error("not implemented");
}
